<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <div class="page-header mt-1">
          <img height="150px" :src="logoImgSrc" alt="">
        </div>
      </v-toolbar-title>
      <v-spacer>
      </v-spacer>

      <TopMenu v-if="countOfImg == 1"/>
      <TopNav v-if="countOfImg == 3"/>

      <v-btn-toggle small v-model="toggleExclusive">
        <v-btn small flat>
          <img
            src="https://www.crwflags.com/fotw/images/d/de.gif"
            height="12px"
            alt="de"
          >
        </v-btn>
        <v-btn small flat>
          <img
            src="https://www.crwflags.com/fotw/images/g/gb.gif"
            height="12px"
            alt="en"
          >
        </v-btn>
      </v-btn-toggle>
    </v-toolbar>

    <v-content>
        <carousel v-if="showCarousel" class="image-carousel" perPage=1>
          <slide v-for="(item,i) in items" :key="i">
            <v-img :src="item.src" alt="" @click=onClick(item.name)></v-img>
          </slide>
        </carousel>
      <v-container fluid>
        <router-view></router-view>
        <!--<EmptyContent v-for="index in 10" :key="index"/>-->
        <Footer />
      </v-container>
      <v-snackbar
        v-model="snackbar"
        :bottom="true"
        :timeout="6000"
      >
        {{ snackbarText }}
        <v-btn
          color="pink"
          flat
          @click="snackbar = false"
        >
          {{snackbarBtn}}
        </v-btn>
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'

import EmptyContent from './components/EmptyContent'
import { Carousel, Slide } from 'vue-carousel'
import NavTop from './views/image-grid/NavTop'
import NavBottom from './views/image-grid/NavBottom'
import ThreeColumnText from './views/image-grid/ThreeColumnText'
import NavMenu from './views/image-grid/NavMenu'

import TopNav from './views/image-grid/main_navigation/TopNav'
import TopMenu from './views/image-grid/main_navigation/TopMenu'
import Footer from './views/image-grid/main_navigation/Footer'

import { EventBus } from './events.js'

const COUNT_OF_IMG_FOR_MOBILE = 1
const COUNT_OF_IMG_FOR_PC = 3
const MOBILE_WIDTH = 900

const POP_UP_DE = 'Diese Website verwendet keine Cookies'
const POP_UP_EN = 'This website does not use cookies'
const POP_UP_BTN_DE = 'Schließen'
const POP_UP_BTN_EN = 'Close'

export default {
  name: 'App',
  components: {
    EmptyContent,
    Carousel, 
    Slide,
    NavTop,
    NavBottom,
    ThreeColumnText,
    NavMenu,
    TopNav,
    TopMenu,
    Footer,
  },
  data () {
    return {
      snackbar: true,
      snackbarText: POP_UP_DE,
      snackbarBtn: POP_UP_BTN_DE,
      showCarousel: true,
      countOfImg: 0,
      imgSelected: '',
      countOfImagesForMobileDev: COUNT_OF_IMG_FOR_MOBILE,
      window: {
        width: 0
      },

      toggleExclusive: 0,
      logoImgSrc: require('@/assets/logo_ib.svg'),
      itemsForLogos: [
        {
          name: 'ImageCity01',
          src:  require('@/assets/rsz_1.png')
        },
        {
          name: 'ImageCity02',
          src: require('@/assets/rsz_2.png')
        },
        {
          name: 'Logo_IBnds_24102018',
          src: require('@/assets/rsz_3.png')
        },
      ],
      
  

      items: [
        {
          name: 'siema--pink 1',
          src: require('@/assets/1aaa.jpg')
        },
        {
          name: 'siema--yellow 2',
          src: require('@/assets/2aaa.jpg')
        },
        {
          name: 'siema--pink 3',
          src: require('@/assets/3aaa.jpg')
        },
      ]
    }
  },
  mounted() {
    EventBus.$on('show', data => {
      this.showCarousel = data;
    });

    EventBus.$on('language', lang => {
      if(lang == 'DE'){
        this.snackbarText = POP_UP_DE
        this.snackbarBtn = POP_UP_BTN_DE
      } else {
        this.snackbarText = POP_UP_EN
        this.snackbarBtn = POP_UP_BTN_EN
      }
    })
  },
  
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    console.log(`width: ${this.window.width}`)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    ...mapState('ContactModule', [ 
                                    'homeNavTitle',
                                    'contactNavTitle',
                                    'aboutNavTitle',
                                    'trainingNavTitle',
                                    'privateDataPolicyNavTitle',
                                    'imprintNavTitle',
                                    'aducationNavTitle',
                                    'programNavTitle',
                                    'imageName',
                                    ]),
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth
      this.setImgCount()
    },
    setImgCount(){
      if(this.window.width < MOBILE_WIDTH){
        this.countOfImg = COUNT_OF_IMG_FOR_MOBILE
      }
      else{
        this.countOfImg = COUNT_OF_IMG_FOR_PC
      }
    },
    onClick(imgName){
      this.imgSelected = imgName
    }
  },
  watch: {
    toggleExclusive(val){
      console.log(val)
      if(val == 0){
        this.$store.dispatch('ContactModule/setLang', 'DE')
        this.$store.dispatch('ContactModule/changeLang', 'DE')
        EventBus.$emit('language', 'DE')
      }
      else{
        this.$store.dispatch('ContactModule/setLang', 'EN')
        this.$store.dispatch('ContactModule/changeLang', 'EN')
        EventBus.$emit('language', 'EN')
      }
    }
  }
}
</script>
<style>
  .image-carousel{
    padding-top: 0.1em;
  }
  .page-header {
    padding-top: 0.2em;
  }
  .logo-header {
    padding-left: 0.2em;
  }
</style>

